// extracted by mini-css-extract-plugin
export default {"emailContainer":"email_emailContainer__UhKac","boxes":"email_boxes__QXOC8","box":"email_box__PrV9T","number":"email_number__L2wdK","percentage":"email_percentage__R4xN4"};